<div class="box-management" *ngIf="canViewWebhookHistory()">
  <div class="header-box">
    <div class="title-box">
      <div>
        <i class="app-icon-timer"></i>
        HISTÓRICO DE WEBHOOK
      </div>
    </div>
  </div>

  <div class="webhook-filter">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>EVENTO</mat-label>
      <mat-select [(ngModel)]="selectedEvent" (ngModelChange)="onFilterChange()">
        <mat-option value="">Todos</mat-option>
        <mat-option *ngFor="let event of eventTypes" [value]="event">{{ getEventLabel(event) }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field subscriptSizing="dynamic">
      <mat-label>RESULTADO</mat-label>
      <mat-select [(ngModel)]="selectedResult" (ngModelChange)="onFilterChange()">
        <mat-option value="ALL">Todos</mat-option>
        <mat-option value="SUCCESS">Sucesso</mat-option>
        <mat-option value="ERROR">Falha</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="history-content" [perfectScrollbar]="{ suppressScrollX: true }">
    <div class="empty-state" *ngIf="!loading && (!items || items.length === 0)">
      Nenhum envio de webhook encontrado.
    </div>

    <div class="timeline" *ngIf="items?.length > 0">
      <div class="timeline-item" *ngFor="let item of items; let last = last" [class.last]="last">
        <div class="timeline-left">
          <div class="icon-circle" [ngClass]="{ 'icon-ok': item.success, 'icon-error': !item.success }">
            <i class="material-icons">{{ item.success ? 'check_circle' : 'error' }}</i>
          </div>
          <div class="timeline-line"></div>
        </div>

        <div class="timeline-right">
          <div class="item-header">
            <span class="item-type-label">{{ getResultLabel(item) }}</span>
          </div>

          <div class="timestamp-top">
            {{ item.createdAt | date: "dd/MM/yyyy" }} às {{ item.createdAt | date: "HH:mm" }}
          </div>

          <div class="provider-text">
            <small>{{ getEventLabel(item.event) }}{{ item.manualResend ? ' · Reenvio manual' : '' }}</small>
          </div>

          <div class="details-box" *ngIf="item.showingDetails && showDetailsLink(item)">
            <small *ngIf="item.webhookUrl"><b>URL: </b>[POST] {{ item.webhookUrl }}</small>
            <small *ngIf="item.requestBody"><br/><b>Request body: </b></small>
            <pre *ngIf="item.requestBody">{{ item.requestBody }}</pre>
            <small *ngIf="item.responseBody"><b>Response: </b></small>
            <pre *ngIf="item.responseBody">{{ item.responseBody }}</pre>
            <small *ngIf="item.errorMessage"><b>Erro: </b>{{ item.errorMessage }}</small>
            <small *ngIf="item.resentByUserName"><br/><b>Reenviado por: </b>{{ item.resentByUserName }}</small>
          </div>

          <div class="details-link" *ngIf="showDetailsLink(item)">
            <span class="link" (click)="openDetailsLink(item)" *ngIf="!item.showingDetails">ver detalhes</span>
            <span class="link" (click)="closeDetailsLink(item)" *ngIf="item.showingDetails">esconder detalhes</span>
            <span class="link resend-link" *ngIf="!item.success" (click)="resend(item)">
              {{ loadingResendId === item.id ? 'reenviando...' : 'reenviar' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer-box" *ngIf="canShowMore()">
    <span class="view-all-link" *ngIf="canShowMore() && numberOfPages <= 1" (click)="onClickFullHistory()">
      VER TODOS ({{ totalElements }})
    </span>

    <div class="pagination-box" *ngIf="numberOfPages > 1">
      <button type="button" (click)="previousPage()" [disabled]="loading || currentPage < 1">Anterior</button>
      <span>{{ currentPage + 1 }} / {{ numberOfPages }}</span>
      <button type="button" (click)="nextPage()" [disabled]="loading || currentPage + 1 >= numberOfPages">Próxima</button>
    </div>
  </div>
</div>
